import { useEffect } from 'react';

export const SPONSORED_CAROUSEL_SCROLL_EVENT = 'sponsoredCarouselScrollEvent';

export const useScrollSponsoredCarousel = (
  canScrollRight: boolean,
  onControlClick: (direction: 'left' | 'right') => void,
  carouselId?: string,
) => {
  useEffect(() => {
    if (!carouselId) {
      return;
    }

    const scroll = (event: CustomEventInit<{ carouselId?: string }>) => {
      if (event.detail?.carouselId === carouselId && canScrollRight) {
        onControlClick('right');
      }
    };

    document.body.addEventListener(SPONSORED_CAROUSEL_SCROLL_EVENT, scroll);

    return () => {
      document.body.removeEventListener(SPONSORED_CAROUSEL_SCROLL_EVENT, scroll);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [canScrollRight, onControlClick]);
};
